import { Box, Select, Text } from '@chakra-ui/react';
import { ExecOptionsWithStringEncoding } from 'child_process';
import { useEffect } from 'react';

type SelectFilterSearchDateProps = {
  label: string;
  placeholder?: string;
  options: {
    option: string;
    value: string;
    idWebsite?: string;
  }[];
  value?: string;
  handleChange: (site: string) => void;
};

export const SelectFilterSearchDate = ({
  label,
  placeholder,
  options,
  value,
  handleChange
}: SelectFilterSearchDateProps) => {
  return (
    <Box
      m="10px 0 0 0  !important"
      w="200px"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      gridGap="10px"
    >
      <Text
        color="#1F1E1F"
        fontSize="1rem"
        fontWeight="400"
        lineHeight="1.5rem"
      >
        {label}
      </Text>
      <Select
        h="48px"
        placeholder={placeholder}
        value={value}
        color={value === '' ? ' #828282' : '#001E64'}
        variant="outline"
        borderRadius="24px"
        border="1px solid #001E64 !important"
        onChange={(e) => {
          handleChange(e.target.value);
        }}
        _hover={{}}
        _active={{}}
        _focus={{
          '&:focus': {
            boxShadow: 'none !important'
          }
        }}
      >
        {options.map((item, index) => {
          return (
            <option
              key={index}
              style={{ color: ' #828282' }}
              value={item.value}
            >
              {item.option}
            </option>
          );
        })}
      </Select>
    </Box>
  );
};
